import React from "react";
import { ArrowRight, LucideIcon } from "lucide-react"; // Import LucideIcon type
import { cardData } from "../../types/Types";

const Card: React.FC<cardData> = ({
  // Renamed 'card' to 'Card' for React convention
  icon, // No destructuring as 'Icon' here, use 'icon' directly
  title,
  description,
  image, // Still keeping image as a separate prop if needed for other use cases
  link, // Added 'link' prop as it's in cardData and used in <a>
}) => {
  console.log(
    "Card component rendered with title:",
    title,
    "Icon type:",
    typeof icon
  );

  // Determine if 'icon' is a Lucide React component or a string (image path)
  const isLucideIcon = typeof icon !== "string";
  const IconComponent = icon as LucideIcon; // Cast for TypeScript if it's a LucideIcon

  return (
    <div
      className="
      group // Enable group-hover utility classes
      bg-white p-6 rounded-lg shadow-md border border-it-card-border
      flex flex-col items-center text-center
      min-h-[280px]
      relative
      transform transition-all duration-300 ease-in-out
      hover:-translate-y-2
      hover:shadow-xl"
    >
      <div className="icon-wrapper mb-4 text-it-solutions-blue">
        {/* Conditionally render based on the type of 'icon' */}
        {isLucideIcon ? (
          // If it's a LucideIcon component
          <IconComponent
            size={48}
            strokeWidth={1.5}
            className="transition-transform duration-300 ease-in-out group-hover:animate-flip-y"
          />
        ) : (
          // If it's a string (image path), render an <img>
          <img
            src={image as string} // Cast to string since it's an image path
            alt={title}
            height={48}
            width={48}
            className="mx-auto transition-transform duration-300 ease-in-out group-hover:animate-flip-y"
          />
        )}
      </div>

      <h3 className="text-xl font-bold mb-2 text-it-text-dark">{title}</h3>
      <p className="text-it-text-light text-sm mb-4 leading-relaxed flex-grow">
        {description}
      </p>
      <a
        href={link} // Use the 'link' prop from cardData
        className="text-it-solutions-blue hover:text-blue-700 font-semibold transition-colors text-sm inline-flex items-center"
      >
        Read More
        <ArrowRight className="ml-1 w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
      </a>
    </div>
  );
};

export default Card;
